import Tooltip from 'rc-tooltip';
import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import { overlayStyle } from '@/components/tooltip/styled';
import { ScInfoIconWrapper, ScInfoTooltip, ScInfoTooltipText } from './styled';

const overlayInnerStyle: React.CSSProperties = {
  background: '#fff',
  borderRadius: '12px',
  border: 'none',
  padding: '12px',
  boxShadow:
    '0px 0px 12px 0px rgba(0,0,0,0.6), 0px 0px 8px 0px rgba(0,0,0,0.2)',
};

interface IInfoTooltipProps {
  children: ReactNode;
  isMobile?: boolean;
}

export const InfoTooltip: FC<IInfoTooltipProps> = ({ children, isMobile }) => {
  const { t } = useTranslation('vip');

  const overlay = (
    <ScInfoTooltip>
      <ScInfoTooltipText>
        {t('steps.vipTransfer.transferForm.infoTooltip')}
      </ScInfoTooltipText>
      <ImageComponent
        alt="email preview"
        height={106}
        src="/vip/email-preview.webp"
        width={284}
      />
    </ScInfoTooltip>
  );

  return (
    <Tooltip
      overlay={overlay}
      overlayInnerStyle={overlayInnerStyle}
      overlayStyle={overlayStyle}
      placement="top"
      showArrow={false}
      trigger={isMobile ? ['click'] : ['hover']}
    >
      <ScInfoIconWrapper onClick={(e) => e.stopPropagation()}>
        {children}
      </ScInfoIconWrapper>
    </Tooltip>
  );
};
